import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import EllipsisHorizontal from 'apollo-react-icons/EllipsisHorizontal';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { updateControlProperty } from '../../../actions/report-designer.actions';
import PropertyModal from '../../../components/ControlProperty/PropertyModal';
import { getPropertyValueToDisplay } from '../../../utils/report-designer.utils';

const useStyles = makeStyles({
  smallMargin: {
    margin: '8px 0',
  },
  withoutMargin: {
    margin: 0,
  },
});

const TextFieldCell = ({ row, column, isInExpandableRow }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [localValue, setLocalValue] = useState();
  const [openModal, setOpenModal] = useState(false);

  const { accessor } = column;
  const { controlId } = row;
  const value = row[accessor];

  useEffect(() => {
    const valueToDisplay = getPropertyValueToDisplay(value);
    setLocalValue(valueToDisplay);
  }, [value]);

  const handleBlur = ({ target }) => {
    if (target.value !== value) {
      dispatch(updateControlProperty(controlId, accessor, target.value));
    }
  };

  return (
    <>
      <TextField
        className={isInExpandableRow ? classes.withoutMargin : classes.smallMargin}
        fullWidth
        value={localValue ?? ''}
        icon={<EllipsisHorizontal />}
        iconProps={{ onClick: () => setOpenModal(true) }}
        onBlur={handleBlur}
        onChange={({ target: { value } }) => setLocalValue(value)}
      />
      {openModal && (
        <PropertyModal
          label={accessor}
          controlId={controlId}
          name={accessor}
          onClose={() => setOpenModal(false)}
        />
      )}
    </>
  );
};

export default TextFieldCell;
